import React, { ReactNode } from 'react'
import styles from './styles/btn-with-chevron.module.scss'
import classNames from 'classnames'

interface BtnWithChevronProps {
  children: ReactNode
  onClick?: () => any
  isDisabled?: boolean
  direction?: string
  className?: string
}

const BtnWithChevron = ({
  onClick,
  direction = 'right',
  isDisabled = false,
  children,
  className = '',
}: BtnWithChevronProps) => {
  return (
    <button
      type='button'
      className={classNames(styles.btnNext, className, { [styles.disabled]: isDisabled })}
      onClick={onClick}
      disabled={isDisabled}
    >
      {direction === 'left' && (
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width='24'
          height='24'
          fill='none'
          viewBox='0 0 24 24'
        >
          <path
            stroke='#003A70'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth='1.5'
            d='M9.9 7.5l4.8 4.5-4.8 4.5'
          />
        </svg>
      )}

      {children}

      {direction === 'right' && (
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width='24'
          height='24'
          fill='none'
          viewBox='0 0 24 24'
        >
          <path
            stroke='#003A70'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth='1.5'
            d='M9.9 7.5l4.8 4.5-4.8 4.5'
          />
        </svg>
      )}
    </button>
  )
}

export default BtnWithChevron
